import React from "react";

// import custom from '../assets/js/custom.js'

function Footer(){
    return(
        <div>
            <script></script>
        </div>
    )
}

export default Footer;